export default __webpack_public_path__ + "54896a5ceac1a9bd438fa4c0c5b22114.svg";